import { legacyPlugins } from "/usr/src/app/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.155.0_@rsbuild+core@2.2.14_@rspack+core@2.2.9_@s_157ab9c93c20f4b2d661bb67522d2137/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}